/* ==========================================================================
   Aspire Leadership — form validation
   Inline, on blur and on submit. Messages name what is wrong and how to fix
   it; they don't apologise and they aren't vague.
   Native `{% form 'contact' %}` still does the submitting — this only guards
   the round trip and drives the loading state.
   ========================================================================== */
(function () {
  'use strict';

  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var PHONE = /^[\d\s().+-]{7,}$/;

  function message(input, label) {
    var v = input.value.trim();
    var type = input.getAttribute('type');

    if (!v) {
      if (input.tagName === 'SELECT') return 'Choose a ' + label.toLowerCase() + ' from the list.';
      return 'Enter your ' + label.toLowerCase() + ' so we can respond.';
    }
    if (type === 'email' && !EMAIL.test(v)) {
      return 'That address is missing an @ or a domain. Try name@example.com.';
    }
    if (type === 'tel' && !PHONE.test(v)) {
      return 'Use digits only, with or without spaces — for example 780 996 4930.';
    }
    if (input.tagName === 'TEXTAREA' && v.length < 10) {
      return 'Add a little more detail — at least a sentence helps us route this.';
    }
    return null;
  }

  function validateField(field) {
    var input = field.querySelector('input, select, textarea');
    if (!input) return true;

    var required = field.getAttribute('data-required') === 'true';
    var label = field.getAttribute('data-label') || 'this field';
    var errEl = field.querySelector('.field__error');
    var empty = !input.value.trim();

    /* Optional and empty: nothing to complain about. */
    if (!required && empty) {
      field.classList.remove('has-error');
      if (errEl) errEl.textContent = '';
      input.removeAttribute('aria-invalid');
      return true;
    }

    var msg = message(input, label);
    if (msg) {
      field.classList.add('has-error');
      if (errEl) errEl.textContent = msg;
      input.setAttribute('aria-invalid', 'true');
      return false;
    }
    field.classList.remove('has-error');
    if (errEl) errEl.textContent = '';
    input.removeAttribute('aria-invalid');
    return true;
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-validate]'), function (form) {
    var fields = Array.prototype.slice.call(form.querySelectorAll('[data-field]'));

    fields.forEach(function (field) {
      var input = field.querySelector('input, select, textarea');
      if (!input) return;
      /* Validate on blur, then live-correct once it has already errored —
         so the visitor sees the error clear as they fix it. */
      input.addEventListener('blur', function () { validateField(field); });
      input.addEventListener('input', function () {
        if (field.classList.contains('has-error')) validateField(field);
      });
      input.addEventListener('change', function () {
        if (field.classList.contains('has-error')) validateField(field);
      });
    });

    form.addEventListener('submit', function (e) {
      var firstBad = null;
      fields.forEach(function (field) {
        if (!validateField(field) && !firstBad) firstBad = field;
      });

      if (firstBad) {
        e.preventDefault();
        var input = firstBad.querySelector('input, select, textarea');
        if (input) input.focus();
        firstBad.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }

      var btn = form.querySelector('[type="submit"]');
      if (btn) {
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
      }
    });
  });

  /* After a successful post Shopify returns ?contact_posted=true — scroll the
     confirmation into view rather than leaving the visitor at the top. */
  if (window.location.search.indexOf('contact_posted=true') > -1) {
    var ok = document.querySelector('.form-success');
    if (ok) {
      ok.setAttribute('tabindex', '-1');
      ok.scrollIntoView({ block: 'center' });
      ok.focus({ preventScroll: true });
    }
  }
})();
